<div id="referal-modal" *ngIf="isModalVisible">
    <div style="position: relative;" class="modal-dialog modal-dialog-centered modal-sm"
        (click)="$event.stopPropagation()">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Refer & Earn ₹5000!</h5>
                <button type="button" class="close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="modal-body" style="padding: 0.25rem;">
                    <p>It’s Time To Be a Friend Indeed!</p>
                    <p>Invite your friends, family, agents, or builders to join BuyRentSale and earn rewards worth up to &#8377;5000 when they make a new purchase. Plus, your referral will enjoy an exclusive discount too, making it a win-win for everyone!&rdquo;</p>
                    <div style="display: flex; flex-wrap: wrap; align-items: center;">
                        <input type="text" [(ngModel)]="mobileNumber" class="form-control"
                            placeholder="Enter your Mobile No" style="height: 30px; width: 100%; margin-bottom: 5px;"
                            autocomplete="off">

                        <button type="button" class="btn btn-primary d-flex align-items-center" (click)="requestOTP()"
                            [disabled]="!mobileNumber || mobileNumber.length < 10 || isLoader"
                            style="margin-right: 5px; height: 30px; font-size: 12px;">
                            <span *ngIf="!isLoader" style="margin-bottom: 2px;">Get OTP</span>
                            <div *ngIf="isLoader" class="spinner-border spinner-border-sm text-light" role="status"
                                style="width: 1rem; height: 1rem;">
                            </div>
                        </button>

                        <!-- Loader or checkmark to the right of the button -->
                        <span *ngIf="otpSent && !isLoader"
                            style="color: green; margin-left: 5px; font-size: 24px;">&check;</span>
                    </div>

                    <input type="text" [(ngModel)]="otp" class="form-control" placeholder="Enter OTP"
                        style="height: 30px; width: 100%; margin-top: 15px;" autocomplete="off">
                    <button type="button" class="btn btn-primary d-flex align-items-center" (click)="joinReferral()"
                        [disabled]="!otp" style="height: 30px; margin-top: 5px;"> <!-- Added margin-top here -->
                        <span style="margin-bottom: 2px;">Join</span>
                    </button>
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-between">
                <button type="button" class="btn btn-secondary" style="font-size: smaller; height: 30px;"
                    (click)="closeModal()">Close</button>
            </div>

        </div>
    </div>
</div>